// You should place a default event image at /public/assets/default-event.jpg
// For now, we'll use the existing podium image as fallback in the service

export const DEFAULT_EVENT_IMAGE = '/assets/podium.png';
